<template>
    <bk-frame :routePrefix="'/sport'"
              :hidenav="false"
              :on-showed="onFrameShowed"
              :on-destroying="onFrameDestroying" />
</template>

<script>
    import Vue from 'vue';

    import BkFrame from '../../../../../../_common/components/bk-frame.vue';
    import CasinoHomeBanner from "../../../common/banners/casino-banners/casino-home-banner.vue";
    import SportHomeBanner from "../../../common/banners/sport-banners/sport-home-banner.vue";    
    import SportHomeCustomBanner from "../../../common/banners/sport-banners/sport-home-custom-banner.vue";
    import SportColumnBanners from "../../../common/banners/sport-banners/sport-column-banners.vue";
    import SportTopBanner from "../../../common/banners/sport-banners/sport-top-banner.vue";
    import QuickLoginReg from "../../../common/quick-login-reg/quick-login-reg.vue";
    import MpesaPaybill from "../../../common/mpesa-paybill/mpesa-paybill.vue";
    import FakeJackpotBanner from "../../../common/jackpots/jackpot-fake/jackpot-fake.vue";
    import MobileMenu from "../../../common/mobile-menu/mobile-menu.vue";
    import isMobile from 'ismobilejs';

    const templates = {
        CasinoHomeBanner,
        SportHomeBanner,
        SportHomeCustomBanner,
        SportColumnBanners,
        SportTopBanner,
        QuickLoginReg,
        MpesaPaybill,
        FakeJackpotBanner,
        MobileMenu
    };

    export default {
        name: 'sport',
        components: { BkFrame },
        data: () => ({
            isMobile: isMobile.phone || isMobile.tablet,
            components: {}
        }),
        computed: {
            client() {
                return Vue.state.client.get();
            },
            currentRoute() {
                return this.$route.matched[this.$route.matched.length - 1];
            },
            isHomeRoute() {
                return this.currentRoute.name === this.client.view.routing.homeRoute;
            },
            isAutoexpressRoute() {
                return this.currentRoute.name === 'sport-autoexpress';
            }
        },
        methods: {
            onFrameShowed() {
                this.client && setTimeout(() => {

                    if (this.currentRoute.props.default.showBanner) {
                        const settings = this.client.view.banners;

                        this.mount(this.isHomeRoute && settings.casinoHomeBanner, "BpwCenterTopWrap", "CasinoHomeBanner");
                        this.mount(this.isHomeRoute && settings.sportHomeBanner, "BpwCenterTopWrap", "SportHomeBanner");
                        this.mount(this.isHomeRoute && settings.sportCustomBanner, "BpwCenterTopWrap", "SportHomeCustomBanner");
                        this.mount(
                                this.isAutoexpressRoute && !this.isMobile && settings.sportAutoexpressDesktopBannerEnabled, 
                                "BpwCenterTopWrap", 
                                "SportAutoexpressDesktopBanner",
                                "SportTopBanner",
                                { banners: this.client.view.banners.sportAutoexpressDesktopBannerImages });
                        this.mount(
                                this.isAutoexpressRoute && this.isMobile && settings.sportAutoexpressMobileBannerEnabled,
                                "BpwCenterTopWrap",
                                "SportAutoexpressDesktopBanner",
                                "SportTopBanner",
                                { banners: this.client.view.banners.sportAutoexpressMobileBannerImages });
                        this.mount(this.isHomeRoute && this.client.view.bk.bkEmbededFakeJackpot,"BpwCenterTop2Wrap", "FakeJackpotBanner");
                        this.mount(this.client.view.bk.bkEmbededMenu,"BpwCenterBeforeMainMenuWrap", "MobileMenu");
                        this.mount(
                            this.isHomeRoute && settings.sportLeftColumnBottomBannersEnabled,
                            "BpwLeftBottomWrap",
                            "SportLeftColumnBottomBanners",
                            "SportColumnBanners",
                            { banners: this.client.view.banners.sportLeftColumnBottomBanners });

                        this.mount(
                            this.isHomeRoute && settings.sportRightColumnBottomBannersEnabled,
                            "BpwRightBottomWrap",
                            "SportRightColumnBottomBanners",
                            "SportColumnBanners",
                            { banners: this.client.view.banners.sportRightColumnBottomBanners });
                    }

                    this.mount(this.currentRoute.props.default.showLogin && this.client.view.auth.sportQuickLogin, "BpwRightTopWrap", "QuickLoginReg");

                    this.mount(this.client.paymentSystem.mPesaPaybillAllowed, "BpwRightTop2Wrap", "MpesaPaybill");
                });
            },
            onFrameDestroying() {
                this.destroy();
            },
            mount(condition, elemId, name, type, props) {
                if (!condition) {
                    this.destroy(name);
                    return;
                }

                setTimeout(() => {
                    const selector = `#${elemId}`;
                    const elem = document.querySelector(selector);
                    if (!elem) {
                        return;
                    }

                    if (elem.innerHTML !== "" && this.components[name]) {
                        return;
                    }

                    this.destroy(name);
                    elem.innerHTML = "";
                    elem.removeAttribute("class");

                    const componentCtor = Vue.extend(templates[type || name]);
                    const component = new componentCtor({ parent: this, propsData: Object.assign({ elemId }, props) });
                    component.mountedTo = selector;
                    component.$mount(selector);
                    this.components[name] = component;
                });
            },
            destroy(name) {

                if (name) {
                    destroyComponent(name, this.components);
                }
                else {
                    Object.keys(this.components).forEach(key => destroyComponent(key, this.components));
                }

                function destroyComponent(key, components) {
                    try {
                        const component = components[key];
                        if (component) {
                            component.$destroy();
                            delete components[key];
                            let elem = document.querySelector(component.mountedTo);
                            if (elem) {
                                elem.innerHTML = "";
                                elem.removeAttribute("class");
                            }
                        }
                    } catch (e) {
                        console.error(e);
                    }
                }
            }
        },
        async mounted() {
            await Vue.state.client.ensure();
        }
    };
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/sport/sport.vue